<template>
    <div class="public_container">
        <div class="returnNavBar">
            <ReturnNavBar title="个人资料"></ReturnNavBar>
        </div>
        <div class="mobile_container">
            <div class="personal_container">
                <van-form  input-align="right" @submit.prevent="handleSubmit">
                    <van-field name="头像"   label="头像"  placeholder="头像" readonly @click="handleClickEditHead">
                        <template #input>
                            <div class="headerImgUpload">
                                <img :src="userInfoDetail.avatar ? userInfoDetail.avatar: 'https://download.hecoos.com/enlightv/2024-42/1a3b607fe54205013ac90744ec5405bd.jpg'" class="headImg" height="24px"  width="24px" alt="">
                            </div>
                        </template>
                    </van-field>
                    <van-field name="姓名"   label="姓名"  placeholder="姓名" v-model="userInfoDetail.name" readonly ></van-field>
                    <van-field name="手机号"   label="手机号"  placeholder="手机号" v-model="userInfoDetail.phone" readonly is-link @click="handleClickEditPhone"></van-field>
                    <van-field name="密码"   label="密码"  placeholder="设置密码"  readonly is-link @click="handleClickEditPassword">
                        <template #input>
                            <span v-if="userInfoDetail.password">******</span>
                        </template>
                    </van-field>
                    <van-field name="微信号"   label="微信号"  placeholder="未绑定" readonly is-link>
                        <template #input>
                            <span @click="handleClickUnbind">解除绑定</span>
                        </template>
                    </van-field>
                    <van-field name="公众号"   label="公众号"  placeholder="公众号" readonly is-link @click="handleClickOfficial">
                        <template #input>
                            <span >澜精灵ERP</span>
                        </template>
                    </van-field>

                </van-form>
                <van-popup class="official_popup"  :style="{ width: '260px',height: '280px',borderRadius:'8px' }" closeable close-icon="cross" v-model="popupShow">
                    <div class="ta-c">
                        <div class="cover">

                        </div>
                        <h5>扫码关注公众号</h5>
                        <p>用于微信接收消息通知</p>
                    </div>
                </van-popup>
                <van-action-sheet
                    v-model="headActionSheetShow"
                    cancel-text="取消"
                    @cancel="handleCancelHead">
                    <template #default>
                        <div class="van-action-sheet__item ta-c" v-for="item in headActions" @click="handleSelectHead(item)">
                            <span v-text="item.name"></span>
                            <input type="file"  @change="handleClickUploadFile"  v-if="item.value == 1" capture="camera" accept="image/png,image/jpeg,image/gif,image/jpg">
                            <input type="file"  @change="handleClickUploadFile"  v-if="item.value == 2" accept="image/png,image/jpeg,image/gif,image/jpg">
                        </div>
                    </template>
                </van-action-sheet>
                <van-popup v-model="editAvatarDialog"  :style="{ width: '100%',height: '100vh',}">
                    <AvatarCropper :Avatarfile="Avatarfile" :editAvatarDialog.sync="editAvatarDialog" @change="getCropper"  v-if="editAvatarDialog"/>
                </van-popup>
            </div>
        </div>
    </div>
</template>
<script>
import { GetUserInfo,ChangeAvatar } from "@/api/index";
import {mapState} from "vuex";
import ReturnNavBar from '@/components/mComponents/ReturnNavBar.vue'
import AvatarCropper from '@/components/mComponents/AvatarCropper'
import {Dialog,Popup} from "vant";
export default {
    name: 'mobilePersonalDetail',
    data () {
        return {
            userInfoDetail:{},
            popupShow:false,
            headActionSheetShow:false,
            headActions:[
                { name: '拍照',value:1 },
                { name: '从手机相册选择',value:2 },
            ],
            editAvatarDialog: false,
            Avatarfile: '',
        }
    },
    created() {
        this.getUserInfo()
    },
    computed: {
        ...mapState(['userInfo']),
    },
    mounted () {

    },
    methods: {
        // 获取用户信息
        getUserInfo() {
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                overlay:true
            });
            GetUserInfo({}).then((res) => {
                if (res.code == 200) {
                   let {user} = res.data
                   this.userInfoDetail = user
                }
                this.$toast.clear();
            });
        },
        // 更换手机号
        handleClickEditPhone(){
            this.$nextTick(()=>{
                this.$router.push({
                    name:'mobileReplacePhone',
                    query: {},
                })
            })
        },
        // 设置密码
        handleClickEditPassword(){
            this.$nextTick(()=>{
                this.$router.push({
                    name:'mobileEditPassword',
                    query: {},
                })
            })
        },
        // 解除绑定
        handleClickUnbind(){
            Dialog.confirm({
                title: '解除绑定',
                message: '你确定要解除绑定微信吗？解除后将不可微信扫码登录澜精灵ERP！',
                className:'my_dialog',
                confirmButtonColor:'rgba(41, 144, 255, 1)',
            }).then(() => {
                // on confirm
            })
            .catch(() => {
                // on cancel
            });
        },
        // 点击公众号
        handleClickOfficial(){
            this.popupShow = true
        },
        // 修改头像
        handleClickEditHead(){
          this.headActionSheetShow = true
        },
        // 选择上传头像
        handleSelectHead(item){

        },
        handleClickUploadFile(e){
            e.preventDefault();
            this.headActionSheetShow = false
            let that = this
            const file = e.target.files[0];
            this.loading = true
            if (file) {
                var reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = function () {
                    console.log(this.result);
                    that.Avatarfile = this.result
                    that.editAvatarDialog = true

                }
            }
        },

        // 获取裁剪过的头像
        getCropper (data) {
            ChangeAvatar({ avatar:data }).then(res => {
                if (res.code == 200) {
                    this.$toast("更换成功")
                    this.userInfoDetail.avatar = data
                    const userInfo = this.userInfo
                    userInfo.user.avatar = data
                    this.$store.dispatch("saveUserInfo", userInfo);
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 取消选择头像
        handleCancelHead(){

        },
        handleSubmit(){

        }
    },
    components: {
        ReturnNavBar,
        AvatarCropper,
    }
}
</script>

<style lang="scss" scoped>
    .van-action-sheet__item{
        position: relative;
    }
    .van-action-sheet__item input{
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
</style>
